module.exports = __webpack_public_path__ + "img/logo-full-white.26b0e896.png";